import { cn } from '@lyearn/style';
import renderImage from '@/modules/content/utils/renderImage';
import { ExerciseType, ResourceStatusEnum } from '@/types/schema';
import { grayScale } from '@/utils/styles';

export default function getExerciseIcon({
  exercise,
  size = 40,
  className,
}: {
  exercise?: ExerciseType;
  size?: number;
  className?: string;
}) {
  const image = exercise?.cover?.url;
  const status = exercise?.status;

  return renderImage({
    image,
    width: size,
    height: size,
    contentName: exercise?.name!,
    className: cn(
      'object-cover',
      [ResourceStatusEnum.Archived, ResourceStatusEnum.Revoked].includes(status!) ? grayScale : '',
      className,
    ),
  });
}
